import React from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PersonalSettings from './PersonalSettings';
import SecuritySettings from './SecuritySettings';
import OtherSettings from './OtherSettings';
const Settings = () => {

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  return (
    <div style={{marginTop: '75px'}}>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Personal Settings" {...a11yProps(0)} />
          <Tab label="Security Settings" {...a11yProps(1)} />
          <Tab label="Other Settings" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <PersonalSettings/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
       <SecuritySettings/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <OtherSettings/>
      </CustomTabPanel>
    </Box>
    </div>
  )
}

export default Settings
